<script setup lang="ts">
import { computed } from 'vue';
import dayjs from 'dayjs';

const props = defineProps<{
  name: string;
}>();

const greeting = computed(() => {
  const hour = dayjs().hour();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
});
</script>

<template>
  <div class="flex flex-col gap-1">
    <h1 class="text-page text-fg">
      {{ greeting }}, {{ props.name }}
    </h1>
    <p class="text-body text-muted">
      Here's what's happening in your community today.
    </p>
  </div>
</template>
